export default "__VITE_ASSET__COyCeNZt__"